var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "26px",
    viewBox: "0 0 24 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Video-Page-Update-Option-C",
    transform: "translate(-130.000000, -1322.000000)",
    stroke: "#231F20",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-3",
    transform: "translate(130.000000, 958.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1.000000, 365.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.10526316,13.1944444 L8.10526316,16.3739766 L2.30478947,18.4663743 C0.922842105,18.9652047 0,20.2880117 0,21.7710526 L0,23.9763158 L22,23.9763158 L22,21.7710526 C22,20.2880117 21.0765789,18.9652047 19.6946316,18.4663743 L13.8947368,16.3739766 L13.8947368,12.9570175",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6447368,7.01754386 C16.6447368,10.8929825 14.0522105,14.0350877 10.8552632,14.0350877 C7.65773684,14.0350877 5.06578947,10.8929825 5.06578947,7.01754386 C5.06578947,3.14210526 7.65773684,0 10.8552632,0 C14.0522105,0 16.6447368,3.14210526 16.6447368,7.01754386 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6085526,6.37789474 C16.4140263,6.40187135 16.2611842,6.39426901 16.0660789,6.4328655 C14.0936053,6.81649123 12.8274474,6.0948538 11.7413421,4.17555556 C11.0906053,5.43695906 9.05386842,6.4328655 7.38128947,6.4328655 C6.55860526,6.4328655 5.84939474,6.26269006 5.14018421,5.88783626",
    id: "Stroke-5"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.fca1f9ec7b64d6886e34674a5cf65421.svg";
export { ForwardRef as ReactComponent };